import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { LinkButton } from '../../index';
import styles from './styles';
import { Links } from './links';

const useStyles = makeStyles(styles);

interface OwnProps {
  links?: LinkButton[];
}

const LoginDownBar: React.FC<OwnProps> = ({ links }) => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <Hidden mdDown>
        <Grid container item xs={8} style={{ gap: '16px' }}>
          <Links links={links} />
        </Grid>
      </Hidden>
      <Grid
        container
        item
        xs={12}
        lg={4}
        justify={window.innerWidth > 1200 ? 'flex-end' : 'center'}
      >
        <Typography variant="body1" className={classes.logoAlign}>
          <img
            className={classes.logo}
            src="/images/skyoneNewLogo.png"
            alt="Logo Skyone"
          />
        </Typography>
      </Grid>

      <Hidden mdUp>
        <Grid
          container
          justify="center"
          style={{ gap: '16px', marginBottom: 8 }}
        >
          <Links links={links} />
        </Grid>
      </Hidden>
    </React.Fragment>
  );
};

export default LoginDownBar;
